import { render, staticRenderFns } from "./PastDisputesView.vue?vue&type=template&id=a70a05da&scoped=true&"
import script from "./PastDisputesView.vue?vue&type=script&lang=js&"
export * from "./PastDisputesView.vue?vue&type=script&lang=js&"
import style0 from "./PastDisputesView.vue?vue&type=style&index=0&id=a70a05da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70a05da",
  null
  
)

export default component.exports